export default __webpack_public_path__ + "static/media/call.2ec133f1.svg";